import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { ToastService } from '../../shared/services/toast.service';
import { ToastState as ts } from '../../shared/enums/toast-state.enum';
import { TegelModule } from '@scania/tegel-angular-17';
import { GerarSenhaDTO } from './models/gerar-senha.dto';
import { LocalContextService } from '../../shared/services/local-context.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogControlPassComponent } from './dialog-control-pass/dialog-control-pass.component';
import { ControlPass } from './models/control-pass';
import { RecebimentoService } from '../../shared/services/recebimento.service';

@Component({
  selector: 'app-control-pass',
  imports: [ButtonComponent, TegelModule],
  templateUrl: './control-pass.component.html',
  styleUrl: './control-pass.component.scss',
})
export class ControlPassComponent implements OnInit {
  currentLocalId: number | null = null;

  constructor(
    private service: RecebimentoService,
    private toast: ToastService,
    private localContextService: LocalContextService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.localContextService.currentLocalId$.subscribe({
      next: (localId) => {
        this.currentLocalId = localId ? +localId : null;
      },
    });
  }

  gerarSenha() {
    if (!this.currentLocalId) {
      this.toast.showToast(
        ts.error,
        'Selecione o local antes de gerar a senha.',
      );
      return;
    }

    const dto: GerarSenhaDTO = {
      localId: this.currentLocalId,
    };

    this.service.generatePassAndReceiving(dto).subscribe({
      next: (result) => {
        if (result.success) {
          this.toast.showToast(
            ts.success,
            'Senha gerada com sucesso. Aguarde a impressão',
            'CONTROL PASS',
          );
          this.openDialogDetails(result.content);
        }
      },
      error: (e) => {
        this.toast.showToast(ts.error, e.error[0]);
      },
    });
  }

  private openDialogDetails(item: ControlPass) {
    this.dialog.open(DialogControlPassComponent, {
      data: item,
    });
  }
}
